import PropTypes from 'prop-types';
import React, {memo, useEffect, useState} from 'react';
import {MONTHS} from '../../../consts';
import {getYearsFromNow} from '../../../utils/helpers';
import ExpirySelectField from '../ExpirySelectField';

const FEATURE_YEARS_NUMBER = 10;

const createOption = id => ({id, name: id});

const FIELDS = {
    expiryMonth: {
        name: 'expiryMonth',
        placeholder: 'MM',
        options: MONTHS.map(createOption)
    },
    expiryYear: {
        name: 'expiryYear',
        placeholder: 'YYYY',
        options: getYearsFromNow(FEATURE_YEARS_NUMBER).map(createOption)
    }
};

const getValue = (month, year) => (month && year ? `${year}/${month}` : '');

const ExpiryDate = ({
    id, name, onChange, onBlur
}) => {
    const [month, setMonth] = useState('');
    const [year, setYear] = useState('');
    const [touched, setTouched] = useState({
        [FIELDS.expiryMonth.name]: false,
        [FIELDS.expiryYear.name]: false
    });


    const handleOnBlur = event => {
        const {name: targetName} = event.target;

        setTouched(currentTouched => ({...currentTouched, [targetName]: true}));
    };

    const handleChange = event => {
        const {name: targetName, value} = event.target;
        if (targetName === FIELDS.expiryMonth.name) {
            setMonth(`${value}`);
        } else {
            setYear(`${value}`);
        }
        handleOnBlur(event);
    };


    useEffect(() => {
        if (month && year) {
            onChange?.(getValue(month, year));
        }
    }, [month, year]);

    useEffect(() => {
        if (touched[FIELDS.expiryMonth.name] && touched[FIELDS.expiryYear.name]) {
            onBlur?.();
        }
    }, [touched]);

    return (
        <div className="expiry-date">
            <ExpirySelectField
                {...FIELDS.expiryMonth}
                onChange={handleChange}
                onBlur={handleOnBlur}
                value={month}
            />
            <ExpirySelectField
                {...FIELDS.expiryYear}
                onChange={handleChange}
                onBlur={handleOnBlur}
                value={year}
            />
            <input
                type="hidden"
                name={name}
                id={id}
                value={getValue(month, year)}
            />
        </div>
    );
};

ExpiryDate.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    onBlur: PropTypes.func
};

ExpiryDate.defaultProps = {
    onChange: null,
    onBlur: null
};

export default memo(ExpiryDate);
